import React, { useEffect } from "react";
import { RouterProvider } from "react-router";
import { ThemeProvider, CssBaseline } from "@mui/material";
import { ToastContainer } from "react-toastify";
import { observer } from "mobx-react";
import { reaction } from "mobx";
import "react-toastify/dist/ReactToastify.css";
import authStore from "./stores/AuthStore.js";
import { getTheme } from "./theme";
import { useTheme as useNextTheme } from "next-themes";
import router from "./routes/Routers.js";

const App = observer(() => {
  const { theme, resolvedTheme, setTheme } = useNextTheme();

  useEffect(() => {
    const disposer = reaction(
      () => authStore.userPreference.theme,
      (newTheme) => {
        setTheme(newTheme || "Light");
      }
    );
    return () => disposer();
  }, [setTheme]);

  const effectiveTheme =
    theme === "System" ? resolvedTheme || "Light" : theme || "Light";
  const muiTheme = getTheme(effectiveTheme.toLowerCase());

  return (
    <ThemeProvider theme={muiTheme}>
      <CssBaseline />
      <RouterProvider router={router} />
      <ToastContainer
        position="top-right"
        autoClose={3000}
        hideProgressBar={false}
        newestOnTop={false}
        closeOnClick
        rtl={false}
        pauseOnFocusLoss
        draggable
        pauseOnHover
        theme="colored"
      />
    </ThemeProvider>
  );
});

export default App;
